export const navbarSections = [
  'Overview',
  'The Who',
  'The What',
  'The Where',
  'The How',
  'Summary',
] as const;
